export default __webpack_public_path__ + "static/media/TyperecordWith.3d875d22.svg";